<template>
  <div class="currency-upsert-form">
    <div class="input-group">
      <dg-input type="text" v-model="formData.name" placeholder="Name" />
      <dg-input type="text" v-model="formData.rate" placeholder="Rate" />

      <el-button type="primary" icon="el-icon-upload" @click="handleAction">Save</el-button>
    </div>
  </div>
</template>

<script>
import Picker from '@/components/shared/CollectionPicker'

export default {
  name: 'CurrencyUpsertForm',
  components: { Picker },
  props: {
    currency: {
      type: Object
    }
  },
  data () {
    return {
      formData: {
        name: '',
        rate: ''
      }
    }
  },
  methods: {
    handleAction () {
      if (this.currency) {
        this.update()
      } else {
        this.add()
      }
    },
    async add () {
      const response = await this.$http.post(this.$api.currencies.add, this.formData)
      this.$message.success('Currency added successfully')
      this.$emit('add', response.data)
    },
    async update () {
      const response = await this.$http.put(this.$api.currencies.update(this.currency.id), this.formData)
      this.$message.success('Currency updated successfully')
      this.$emit('update', response.data)
    }
  },
  created () {
    if (this.currency) {
      this.formData.name = this.currency.name
      this.formData.rate = this.currency.rate
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/currencies/UpsertForm.vue